import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useAppBar } from '../../../../components/appBar/appBarContext';
import TableCard from '../../../../components/card/tableCard/tableCard';
import CheckDocumentIcon from '../../../../components/icons/CheckDocumentIcon';
import { LOAN_CARD_INFO } from '../../../../config/cacheKey';
import { IChequeDelivery } from '../../../../models/cheque.model';
import { IGetLoansInfoResponse } from '../../../../models/registration.model';
import { changeRouteType } from '../../../../redux/handleBackBtn/handleBackBtnSlice';
import { AppDispatch } from '../../../../redux/store';
import { GetChequesForDelivery } from '../../../../services/cheque.service';
import { IContainerApp } from '../../../navigationButtonComponents/loansTab/containerApp/IContainerApp';
import LoanCardSkeleton from './LoanCardSkeleton';

export default function CheckDocument({ referenceKey, setStep, stepMain }: IContainerApp) {
    const [data, setData] = useState<IChequeDelivery>();
    const { setHeader } = useAppBar();
    const dispatch: AppDispatch = useDispatch();
    const queryClient = useQueryClient();
    const cache = queryClient.getQueryData(LOAN_CARD_INFO) as IGetLoansInfoResponse;
    const checkStepMain = stepMain ? stepMain : cache!.loanRequestStatusId;
    const { mutateAsync: getChequesForDeliveryMutation, isLoading } = useMutation(
        GetChequesForDelivery,
        {
            onSuccess: (data: IChequeDelivery) => {
                setData(data);
            },
        }
    );
    useEffect(() => {
        dispatch(changeRouteType({ routeType: 'infoDetail' }));
        if (checkStepMain === 'WaitForDocumentReceiveApprove') {
            setHeader('در انتظار ارسال مدارک', 'checkDoc');

            getChequesForDeliveryMutation({
                referenceKey: referenceKey!,
            });
        }
        else {
            setHeader('در انتظار بررسی مدارک', 'checkDoc');

        }
    }, []);
    const addres = data?.address;
    if (isLoading) {
        return <LoanCardSkeleton />
    }
    return (
        <div style={{ textAlign: 'center' }} className="!mt-10">

            <>
                {
                    checkStepMain === 'WaitForDocumentReceiveApprove' ? <><Typography
                        sx={{ fontSize: '.9em' }}
                        className="secondaryColorLight-600 !mt-10"
                    >
                        درخواست شما مورد تایید قرار گرفت
                        لطفا چک‌هایی که شماره صیادی آنها در جدول زیر اعلام شده، به آدرس
                        <b className="secondaryColorLight-600 ">&nbsp; {addres} </b> ارسال فرمایید
                    </Typography><div className="mt-3">
                            <TableCard
                                date="سررسید"
                                price="مبلغ (ریال)"
                                sayadNumber="شماره صیادی"
                                element="header" />
                        </div><div className="mt-3">
                            {data?.cheques?.map((item) => (
                                <TableCard
                                    date={item!.dueDatePersian}
                                    price={item!.amount.toLocaleString('fa')}
                                    sayadNumber={item!.sayadNumber}
                                    element="body" />
                            ))}
                        </div></>
                        :
                        <div className="flex flex-col items-center justify-center">
                            <CheckDocumentIcon className='text-[var(--primary-text-color)]' />
                            <Typography
                                sx={{ fontSize: '.9em' }}
                                className="primaryColorLight-900 !mt-10 "
                            >
                                درخواست شما جهت بررسی برای کارشناسان ما ارسال شده و نتیجه{' '}
                                <b className="secondaryColorLight-600">از طریق پیامک</b> اطلاع
                                رسانی خواهد شد.
                            </Typography>
                        </div>}
            </>


        </div>
    );
}
